import { Trans, useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router';
import { LanguageToggle } from '../components/forms';
import { Icon, type IconName, Mark } from '../components/icons';
import { Button } from '../components/ui';
import { applyLanguage, currentLanguage } from '../lib/i18n';

const FEATURES: [IconName, string][] = [
  ['file-text', 'welcome.featureChat'],
  ['lock', 'welcome.featurePassword'],
  ['calendar', 'welcome.featureMore'],
];

/** A1 · Welcome: what EkApp is, the language switch, and the way in. */
export function Welcome() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className="frame">
      <main className="page welcome" aria-labelledby="welcome-title">
        <div className="page__body">
          <div className="welcome__lang">
            <LanguageToggle
              value={currentLanguage()}
              onChange={(lang) => void applyLanguage(lang)}
              label={t('languages.label')}
            />
          </div>
          <div className="brand">
            <Mark size={60} />
            <h1 className="brand__name" id="welcome-title">
              EkApp
            </h1>
            <p className="brand__tagline">{t('welcome.tagline')}</p>
          </div>
          <figure className="preview" aria-label={t('welcome.previewLabel')}>
            <div className="preview__bot">
              <Mark size={24} />
              <span>{t('welcome.previewAsk')}</span>
            </div>
            <span className="preview__user">{t('welcome.previewUser')}</span>
            <div className="preview__bot">
              <Mark size={24} />
              <span>{t('welcome.previewAnswer')}</span>
            </div>
          </figure>
          <ul className="features">
            {FEATURES.map(([icon, key]) => (
              <li key={key} className="feature">
                <span className="icon-tile icon-tile--small">
                  <Icon name={icon} size={18} />
                </span>
                {t(key)}
              </li>
            ))}
          </ul>
        </div>
        <div className="page__foot">
          <Button icon="smartphone" onClick={() => navigate('/sign-in')}>
            {t('welcome.continue')}
          </Button>
          <p className="footnote">
            <Trans
              i18nKey="welcome.agree"
              components={{ terms: <Link to="/terms" />, privacy: <Link to="/privacy" /> }}
            />
          </p>
        </div>
      </main>
    </div>
  );
}
